import { v4 as uuid } from 'uuid';
export const getContactWishlistData = ({ contactCompany, contactFirstName, contactLastName, contactTitle, contactEmail, contactPhone, parsedDataFullName, parsedDataCompany, parsedLinkedinUrl, url, platform, }) => ({
    contacts: [
        {
            details: {
                firstName: contactFirstName,
                lastName: contactLastName,
                jobTitle: contactTitle,
                emails: contactEmail
                    ? [
                        {
                            value: contactEmail,
                            type: 'work',
                        },
                    ]
                    : [],
                company: Object.assign({}, contactCompany),
                phones: contactPhone
                    ? [
                        {
                            value: contactPhone,
                            type: 'work',
                        },
                    ]
                    : [],
            },
            // wished-contacts rejects null/empty identifiers; only undefined (omitted) skips validation.
            identifiers: {
                linkedinUrl: parsedLinkedinUrl || undefined,
                fullName: parsedDataFullName || [contactFirstName, contactLastName].filter(Boolean).join(' '),
                companyName: parsedDataCompany || (contactCompany === null || contactCompany === void 0 ? void 0 : contactCompany.name) || undefined,
            },
        },
    ],
    requestMetadata: {
        url,
        platform,
        requestId: uuid(),
        searchVersion: '3.0',
    },
});
